import React from "react";
import { BrowserRouter, Route, Switch, Redirect, Router } from "react-router-dom";

import { isAuthenticated } from "./services/auth";
import Home from "./Home/Home";
import Login from "./Auth/Login";
import { useSelector, useDispatch } from 'react-redux'
import EsqueciSenha from "./Auth/EsqueciSenha";
import AlterarSenha from "./Auth/AlterarSenha";
import LinkPagamento from "./Home/LinkPagamento";
import VisualizarSimulacao from "./Home/VisualizarSimulacao";


const PrivateRoute = ({ component: Component, ...rest }) => {
    // const stream = useSelector(state => state.AppReducer.stream);
    const token = useSelector(state => state.AppReducer.token)
    console.log(token);
    return (
        <Route
            {...rest}
            render={props =>
                token != null ? (
                    <Component {...props}>
                        {/* {processo != null && <div>
                            
                        </div>}
                        {/* {processo==null && <OtherRoute path={`${props.match.url}*`}  path_name={`${props.match.url}not_processo`}/>} */}
                    </Component>
                ) : (
                        // <Redirect to={{ pathname: "/", state: { from: props.location } }} />
                        // <SelectFaculdade {...props} />
                        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />

                    )
            }
        />)
};

const LoginRoute = ({ component: Component, ...rest }) => {
    const token = useSelector(state => state.AppReducer.token)
    return (
        <Route
            {...rest}
            render={props =>
                token == null ? (
                    <Component {...props} />
                ) : (
                        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
                    )
            }
        >

        </Route>
        );
};

const OtherRoute = ({ component: Component, path_name, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            <Redirect to={{ pathname: path_name, state: { from: props.location } }} />
        }
    />
);

const Routes = () => {
    const token = useSelector(state => state.AppReducer.token)
    return (
        <BrowserRouter>
            <Switch>
                {/* <Route exact path="/" component={(props) => token == null ? <SelectFaculdade {...props} /> : <Home {...props} />} /> */}

                {/* <Route exact path="/:slug/login" component={(props) => isAuthenticated() == false ? <Login {...props} /> : <Route render={props => <Redirect to={{ pathname: "/", state: { from: props.location } }} />}
            />} /> */}


                <LoginRoute path="/login" component={(props) => <Login {...props} />} />
                
                {/* <LoginRoute path="/recuperar_senha" component={(props) => <EsqueciSenha {...props} />} /> */}
                {/* <LoginRoute path="/reset/:token" component={(props) => <AlterarSenha {...props} />} /> */}

                <Route path="/recuperar_senha" render={(props2) => <EsqueciSenha {...props2} />} />
                <Route path="/reset/:token" render={(props2) => <AlterarSenha {...props2} />} />
                <Route path="/pagamento/:id" render={(props2) => <LinkPagamento {...props2} />} />
                <Route path="/simulacao/:id" render={(props2) => <VisualizarSimulacao {...props2} />} />


                <PrivateRoute path="/" component={(props) => <Home {...props} />} />

                <OtherRoute path="*" path_name='/' />
            </Switch>
        </BrowserRouter>
    );
};

export default Routes;